export function calculateRewardPoints(price) {
    const pointsPerHundred = 1;
    return Math.floor(price / 100) * pointsPerHundred;
  }